"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributes = exports.tabbableSelectors = void 0;
exports.tabbableSelectors = {
    elements: ['iframe', 'input', 'select', 'textarea', 'button'],
    additional: ['a[href]', '[tabindex]:not([tabindex="-1"])'],
    get all() {
        return [...this.elements, ...this.additional].join(',');
    },
};
exports.attributes = {
    RESTORE_TAB_INDEX: 'data-restore-tabindex',
    ARIA_HIDDEN: 'aria-hidden',
};
//# sourceMappingURL=consts.js.map